<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  created () {
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem('store')) {
          this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      }
      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener('beforeunload', () => {
          sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
  },
  components: {
  }
}
</script>

<style lang="scss">
  @import "./assets/css/common.scss";
  @import './assets/fonts/iconfont.css';
  #app {
    width: 100%;
    // height: 100%;
  }
  @media screen and (min-width: 800px) {
    body {
      min-width: 1900px;
    }
  }
  @media screen and (max-width: 800px) {
    body {
      min-width:375px;
      zoom:0.1
    }
  }
</style>
